import React, { Component } from 'react'

class MissionStatement extends Component {
  render () {
    return (
      <section className='MissionStatement'>
        <h1>OUR MISSION</h1>
        <p>Helping you reach your financial goals, one article at a time.</p>
      </section>
    )
  }
}

export default MissionStatement



// WEBPACK FOOTER //
// ./client/components/MissionStatement/index.js